import {Component, OnInit} from '@angular/core';
import {BmBankTransactionFamilyBaseComponent} from '../bm-bank-transaction-family-base.component';


@Component({
    selector: 'bm-bank-transaction-family-side',
    templateUrl: 'bm-bank-transaction-family-side.component.html',
    standalone: false
})
export class BmBankTransactionFamilySideComponent extends BmBankTransactionFamilyBaseComponent implements OnInit {

    ngOnInit() {
        super.ngOnInit();
    }

}
